import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import FormControlCustom from '../formControlCustom';
import { I18n, Translate } from 'react-redux-i18n';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as settingActions from '../../actions/settingActions';
import * as loadingBarActions from '../../actions/loadingBarActions';
import { VALID_CASE } from '../../constants/commondata';
import TitlePayoutPlan from './components/TitlePayoutPlan';

export const PAYOUT_PLAN_TYPE = {
  default: 'default',
  custom: 'custom',
};

const PayoutPlan = ({
  payoutPlanType,
  onPayoutPlanTypeChange,
  onSupplierPlanIdChange,
  supplierPlanId,
  disabled,
  auth: authReguceMapState,
  ...props
}) => {
  const [supplierPlanOption, setSupplierPlanOption] = useState([
    {
      value: '',
      text: I18n.t('supplierPlan.Select_supplier_plan'),
    },
  ]);

  useEffect(() => {
    const getSupplierPlanOption = async () => {
      let param = {
        limit: 100,
        page: 0,
        fleetId: authReguceMapState?.selectedFleet?.fleetId,
      };
      try {
        const data = await props.settingActions.supplierPlanFind(param);
        if (data.ok) {
          let { list } = data.res || {};
          if (list) {
            setSupplierPlanOption([
              ...supplierPlanOption,
              ...list.map((item) => {
                return {
                  value: item._id,
                  text: item.name,
                };
              }),
            ]);
          }
        }
      } catch (e) {
        console.error(e);
      }
    };
    getSupplierPlanOption();
  }, []);

  const getOptionPayoutTypeFromSetting = () => {
    let NEW_PAYOUT_PLAN_TYPE = { ...PAYOUT_PLAN_TYPE };
    if (
      !authReguceMapState?.selectedFleet?.generalSetting
        ?.differentFleetCommission
    ) {
      delete NEW_PAYOUT_PLAN_TYPE.default;
    }
    return NEW_PAYOUT_PLAN_TYPE;
  };

  return (
    <>
      <TitlePayoutPlan />
      <FormControlCustom
        field={{
          key: 'payoutPlanType',
          type: 'select',
          option: Object.values(getOptionPayoutTypeFromSetting()).map(
            (type) => ({
              value: type,
              text: I18n.t(`supplierPlan.${type}`),
            })
          ),
        }}
        disabled={disabled}
        value={payoutPlanType}
        handleChange={onPayoutPlanTypeChange}
      />
      {payoutPlanType === PAYOUT_PLAN_TYPE.custom && (
        <FormControlCustom
          field={{
            key: 'supplierPlanId',
            type: 'select',
            option: supplierPlanOption || [],
            validCases: [VALID_CASE.required],
          }}
          disabled={disabled}
          value={supplierPlanId}
          handleChange={onSupplierPlanIdChange}
          validatorCallback={props.validatorCallback}
          isSubmitted={props.isSubmitted}
          valid={props.valid}
        />
      )}
    </>
  );
};

PayoutPlan.defaultProps = {
  payoutPlanType: PAYOUT_PLAN_TYPE.default,
  supplierPlanId: '',
  onPayoutPlanTypeChange: () => {},
  onSupplierPlanIdChange: () => {},
  disabled: false,
};

PayoutPlan.propTypes = {
  payoutPlanType: PropTypes.oneOf(Object.values(PAYOUT_PLAN_TYPE)),
  onPayoutPlanTypeChange: PropTypes.func,
  onSupplierPlanIdChange: PropTypes.func,
  supplierPlanId: PropTypes.string,
  disabled: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    settingActions: bindActionCreators(settingActions, dispatch),
    loadingBarActions: bindActionCreators(loadingBarActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PayoutPlan);
